;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    name: {
      required: true,
      type: String
    },
    placeholder: {
      type: String
    },
    value: {
      default: null
    },
    onChange: Function
  },
  data: function data() {
    return {
      fieldValue: this.value
    };
  },

  watch: {
    value: function value() {
      this.fieldValue = this.value;
    }
  },
  methods: {
    onFieldInput: function onFieldInput() {
      this.$emit("input", this.fieldValue);
    },
    onFieldChange: function onFieldChange() {
      this.onChange({ name: this.name, value: this.fieldValue });
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"}],staticClass:"ss-input",attrs:{"name":_vm.name,"placeholder":_vm.placeholder},domProps:{"value":(_vm.fieldValue)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value},function($event){$event.stopPropagation();return _vm.onFieldInput.apply(null, arguments)}],"change":function($event){$event.stopPropagation();return _vm.onFieldChange.apply(null, arguments)}}})}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8abf6ee4", __vue__options__)
  } else {
    hotAPI.reload("data-v-8abf6ee4", __vue__options__)
  }
})()}